<template>
  <div class = "container">
    <div class ="col-sm-4">
      <ul class = "list-group">
        <li v-for = "(att,index) in files" :id = "index" class = "list-group-item border-0">
          Załącznik nr {{index+1}}
          <a :href = "att" target="_blank">
            <button class="attachement-button">
              <i :class = "className[index]"></i>
            </button>
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    files: Array
  },
  data() {
    return {
      extension: [],
      className: []
    };
  },
  methods: {
    filesLog() {
      let fileRead = this.files;
      for (let i = 0; i <= fileRead.length - 1; i++) {
        let extensionStart = fileRead[i].lastIndexOf(".") + 1;
        let fileLength = fileRead[i].length;
        let slice = fileRead[i].slice(extensionStart, fileLength);
        this.extension.push(slice);
        switch (this.extension[i]) {
          case "png":
            this.className.push("fa fa-file-image-o");
            break;
          case "pdf":
            this.className.push("fa fa-file-pdf-o");
            break;
          case "doc":
          case "odt":
            this.className.push("fa fa-file-text-o");
            break;
          case "zip":
            this.className.push("fa fa-file-zip-o");
            break;
          case "xlsx":
          case "xls":
            this.className.push("fa fa-file-excel-o");
            break;
          default:
            this.className.push("fa fa-file-o");
        }
      }
    }
  },

  mounted() {
    this.filesLog();
  }
};
</script>



// WEBPACK FOOTER //
// node_modules/redbay-b2b-products/src/productPage/elements/Attachments.vue